import { Component, ChangeDetectionStrategy } from '@angular/core';

import { BtnAction2Component } from '../btn-action2/btn-action2.component';

@Component({
    selector: 'aa-btn-action2-tertiary',
    templateUrl: '../btn-action2/btn-action2.component.html',
    styleUrls: [
        '../btn-action/btn-action.component.scss',
        '../btn-action-tertiary/btn-action-tertiary.component.scss',
        './btn-action2-tertiary.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BtnAction2TertiaryComponent extends BtnAction2Component
{
    constructor ()
    {
        super();
    }
}
